// DOS CLI Keyboard Navigation and Interactions

document.addEventListener("DOMContentLoaded", function () {
  initializeDOS();
});

function initializeDOS() {
  updateDateTime();
  setInterval(updateDateTime, 1000);

  initializeKeyboardNavigation();
  initializeMenuItems();
  typeWriterEffect();
}

// Update DOS-style date/time
function updateDateTime() {
  const now = new Date();
  const dateTimeElement = document.getElementById("dos-datetime");

  if (dateTimeElement) {
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const year = now.getFullYear();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");

    dateTimeElement.textContent = `${month}-${day}-${year} ${hours}:${minutes}:${seconds}`;
  }
}

// Initialize keyboard navigation
function initializeKeyboardNavigation() {
  const scrollAmount = 200;
  const scrollDelay = 16;
  let selectedIndex = 0;
  const menuItems = document.querySelectorAll(".dos-menu-item");
  const scrollContainer =
    document.querySelector(".dos-content") || document.documentElement;

  if (menuItems.length === 0) return;

  // Set initial selection
  menuItems[selectedIndex].classList.add("selected");

  // Global keyboard handler
  document.addEventListener("keydown", function (e) {
    // if (scrollInterval) return;
    const key = e.key.toLowerCase();

    if (key === "arrowdown" || key === "j") {
      e.preventDefault();
      scrollContainer.scrollBy({ top: scrollAmount, behavior: "smooth" });
    } else if (key === "arrowup" || key === "k") {
      e.preventDefault();
      scrollContainer.scrollBy({ top: -scrollAmount, behavior: "smooth" });
    } else if (key >= "1" && key <= "9") {
      e.preventDefault();
      const index = parseInt(key) - 1;
      if (index < menuItems.length) {
        selectedIndex = index;
        updateSelection(menuItems, selectedIndex);
        setTimeout(() => {
          activateMenuItem(menuItems[selectedIndex]);
        }, 150);
      }
    } else if (key === "enter" || key === " ") {
      e.preventDefault();
      activateMenuItem(menuItems[selectedIndex]);
    } else if (key === "escape") {
      e.preventDefault();
      if (window.history.length > 1) {
        window.history.back();
      }
    } else if (key === "h" && !e.ctrlKey && !e.metaKey) {
      e.preventDefault();
      showHelp();
    } else if (key === "c") {
      e.preventDefault();
      const dosScreen = document.getElementById("dos-screen");
      dosScreen.classList.toggle("flicker");
    }
  });

  // Mouse hover support
  menuItems.forEach((item, index) => {
    item.addEventListener("mouseenter", function () {
      selectedIndex = index;
      updateSelection(menuItems, selectedIndex);
    });

    item.addEventListener("click", function (e) {
      e.preventDefault();
      activateMenuItem(item);
    });
  });
}

// Update selected menu item
function updateSelection(menuItems, selectedIndex) {
  menuItems.forEach((item, index) => {
    if (index === selectedIndex) {
      item.classList.add("selected");

      // Scroll into view if needed
      const container = item.closest(".dos-content");
      if (container) {
        const itemRect = item.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();

        if (itemRect.bottom > containerRect.bottom) {
          item.scrollIntoView({ behavior: "smooth", block: "end" });
        } else if (itemRect.top < containerRect.top) {
          item.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }
    } else {
      item.classList.remove("selected");
    }
  });
}

// Activate menu item
function activateMenuItem(item) {
  const link = item.querySelector("a") || item.dataset.href;

  if (link && typeof link === "string") {
    playActivateSound();
    flashScreen();
    setTimeout(() => {
      window.location.href = link;
    }, 100);
  } else if (link && link.href) {
    playActivateSound();
    flashScreen();
    setTimeout(() => {
      window.location.href = link.href;
    }, 100);
  }
}

// Initialize menu items with proper structure
function initializeMenuItems() {
  const menuItems = document.querySelectorAll(".dos-menu-item");

  menuItems.forEach((item, index) => {
    // Add number if not present
    if (!item.querySelector(".dos-menu-item-number")) {
      const number = document.createElement("span");
      number.className = "dos-menu-item-number";
      number.textContent = `[${index + 1}]`;
      item.insertBefore(number, item.firstChild);
    }

    // Add keyboard hint if not present
    if (!item.querySelector(".dos-menu-item-key")) {
      const keyHint = document.createElement("span");
      keyHint.className = "dos-menu-item-key";
      keyHint.textContent = `Press ${index + 1}`;
      item.appendChild(keyHint);
    }

    // Store href for activation
    const link = item.querySelector("a");
    if (link) {
      item.dataset.href = link.href;
    }
  });
}

// Typewriter effect for elements with data-typewriter attribute
function typeWriterEffect() {
  const elements = document.querySelectorAll("[data-typewriter]");

  elements.forEach((element, elemIndex) => {
    const text = element.textContent;
    element.textContent = "";
    element.style.display = "inline-block";

    let charIndex = 0;
    const delay = parseInt(element.dataset.typewriterDelay) || 50;
    const startDelay = elemIndex * 500;

    setTimeout(() => {
      const interval = setInterval(() => {
        if (charIndex < text.length) {
          element.textContent += text.charAt(charIndex);
          charIndex++;
        } else {
          clearInterval(interval);
        }
      }, delay);
    }, startDelay);
  });
}

// Visual feedback for activation
function flashScreen() {
  const screen = document.querySelector(".dos-screen");
  if (!screen) return;

  screen.style.transition = "opacity 0.05s";
  screen.style.opacity = "0.5";
  setTimeout(() => {
    screen.style.opacity = "1";
  }, 50);
}

// Simple beep sound (visual feedback)
function playBeep() {
  // Visual feedback since we can't play actual audio without user interaction
  const cursor = document.querySelector(".dos-cursor");
  if (cursor) {
    cursor.style.color = "#55FFFF";
    setTimeout(() => {
      cursor.style.color = "#FFFFFF";
    }, 100);
  }
}

// Activation sound (visual feedback)
function playActivateSound() {
  const footer = document.querySelector(".dos-footer");
  if (footer) {
    footer.style.background = "#0000AA";
    setTimeout(() => {
      footer.style.background = "#000000";
    }, 100);
  }
}

// Show help overlay
function showHelp() {
  const existingHelp = document.querySelector(".dos-help-overlay");
  if (existingHelp) {
    existingHelp.remove();
    return;
  }

  const helpOverlay = document.createElement("div");
  helpOverlay.className = "dos-box dos-help-overlay";
  helpOverlay.style.cssText = `
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 9999;
    max-width: 600px;
    background: #000000;
    border: 2px solid #55FFFF;
    box-shadow: 0 0 50px rgba(0, 170, 170, 0.5);
  `;

  helpOverlay.innerHTML = `
    <div class="dos-box-title">KEYBOARD SHORTCUTS</div>
    <div class="dos-text" style="margin: 10px 0;">
      <div style="margin: 8px 0;"><span class="dos-text-highlight">↑/↓</span> or <span class="dos-text-highlight">J/K</span> - Scroll page</div>
      <div style="margin: 8px 0;"><span class="dos-text-highlight">1-9</span> - Select menu item</div>
      <div style="margin: 8px 0;"><span class="dos-text-highlight">ENTER</span> or <span class="dos-text-highlight">SPACE</span> - Activate selection</div>
      <div style="margin: 8px 0;"><span class="dos-text-highlight">ESC</span> - Go back</div>
      <div style="margin: 8px 0;"><span class="dos-text-highlight">C</span> - Enable CRT mode</div>
      <div style="margin: 8px 0;"><span class="dos-text-highlight">H</span> - Toggle this help</div>
    </div>
    <div class="dos-text" style="text-align: center; margin-top: 20px; color: #555555;">
      Press H or ESC to close
    </div>
  `;

  document.body.appendChild(helpOverlay);

  const closeHelp = (e) => {
    if (e.key === "h" || e.key === "H" || e.key === "Escape") {
      helpOverlay.remove();
      document.removeEventListener("keydown", closeHelp);
    }
  };

  document.addEventListener("keydown", closeHelp);

  helpOverlay.addEventListener("click", () => {
    helpOverlay.remove();
    document.removeEventListener("keydown", closeHelp);
  });
}

// Boot sequence animation (if element exists)
function bootSequence() {
  const bootElement = document.querySelector("[data-boot-sequence]");
  if (!bootElement) return;

  const messages = [
    "Starting system...",
    "Loading configuration...",
    "Initializing network drivers...",
    "Checking memory... OK",
    "Loading user interface...",
    "System ready.",
  ];

  bootElement.innerHTML = "";
  let messageIndex = 0;

  const interval = setInterval(() => {
    if (messageIndex < messages.length) {
      const line = document.createElement("div");
      line.textContent = messages[messageIndex];
      line.style.color = "#55FF55";
      bootElement.appendChild(line);
      messageIndex++;
    } else {
      clearInterval(interval);
    }
  }, 300);
}

// Export for use in other scripts
window.DOS = {
  updateDateTime,
  showHelp,
  playBeep,
  flashScreen,
};
